import { Table } from '@radix-ui/themes'
import React from 'react'

import {
  ActionColumnHeaderCell,
  ColumnHeaderCell,
  HeaderRow,
} from './TableFormStyles'

type TableFormHeaderProps = {
  tableColumnHeaders: {
    label: string
    header: string
  }[]
  inEditMode: boolean
}

export const TableFormHeader: React.FC<TableFormHeaderProps> = ({
  tableColumnHeaders,
  inEditMode,
}) => {
  return (
    <Table.Header>
      <HeaderRow>
        {tableColumnHeaders?.map((column) => (
          <ColumnHeaderCell key={column.label}>
            {column.header}
          </ColumnHeaderCell>
        ))}
        {inEditMode && <ActionColumnHeaderCell key={'actions'} />}
      </HeaderRow>
    </Table.Header>
  )
}
